import { Workflow } from '@/app/workflows/actions/interfaces';
import { Badge } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';

export function WorkflowIdBadge({ workflow }: { workflow: Workflow }) {
  const { copy, copied } = useClipboard();
  const text = copied ? 'Copied' : 'id: ' + workflow.id;

  return (
    <Badge
      color={copied ? 'green' : 'grape'}
      onClick={(e) => {
        e.stopPropagation();
        copy(workflow.id.toString());
      }}
      style={{ cursor: 'pointer' }}
    >
      {text}
    </Badge>
  );
}
